import { combineReducers } from "@reduxjs/toolkit";
import LoginReducer from '../common/login/loginSlice'
import getApplicationDataReducer from '../common/getApplicationData/getApplicationDataSlice';
import partnerFileDataReducer from '../../../components/partnerFileUpload/redux/partnerFileUploadSlice';
import engagementQualificationReducer from '../../../components/partnerFileUpload/redux/engagementQualificationSlice';
import userManagementReducer from '../../../components/UserManagement/redux/userManagementSlice';
import deploymentSchedulerReducer from '../../../components/deployment-scheduler/redux/deploymentSchedulerSlice';

const rootReducer = combineReducers({
  login: LoginReducer,
  getApplicationData: getApplicationDataReducer,
  partnerFileData: partnerFileDataReducer,
  engagementQualification: engagementQualificationReducer,
  userManagement: userManagementReducer,
  deploymentScheduler: deploymentSchedulerReducer,
  // Add other reducers here
});

export default rootReducer;
